"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var React = tslib_1.__importStar(require("react"));
var use_context_selector_1 = require("use-context-selector");
var houston_styles_1 = tslib_1.__importDefault(require("@eduzz/houston-styles"));
var Button_1 = tslib_1.__importDefault(require("../../../../Button"));
var Typography_1 = tslib_1.__importDefault(require("../../../../Typography"));
var context_1 = tslib_1.__importDefault(require("../../../context"));
var UserMenuItem = React.forwardRef(function (_a, ref) {
    var id = _a.id, className = _a.className, icon = _a.icon, disabled = _a.disabled, onClick = _a.onClick, children = _a.children, Tag = _a.as, rest = tslib_1.__rest(_a, ["id", "className", "icon", "disabled", "onClick", "children", "as"]);
    var close = (0, use_context_selector_1.useContextSelector)(context_1.default, function (context) { return context.userMenu.falseOpened; });
    var handleClick = React.useCallback(function (e) {
        onClick && onClick(e);
        close();
    }, [close, onClick]);
    var content = ((0, jsx_runtime_1.jsx)(Button_1.default, tslib_1.__assign({ id: id, startIcon: icon, ref: ref, fullWidth: true, variant: 'text', onClick: handleClick, className: className, disabled: disabled }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, tslib_1.__assign({ color: 'inherit' }, { children: children })) })));
    if (Tag) {
        content = ((0, jsx_runtime_1.jsx)(Tag, tslib_1.__assign({ id: id }, rest, { children: content })));
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: content });
});
exports.default = (0, houston_styles_1.default)(UserMenuItem, { label: 'hst-user-menu-item' })(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  justify-content: start;\n  text-align: left;\n\n  &.hst-button-disabled {\n    background-color: transparent;\n  }\n"], ["\n  justify-content: start;\n  text-align: left;\n\n  &.hst-button-disabled {\n    background-color: transparent;\n  }\n"])));
var templateObject_1;
